var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCancelIconHover = function SvgCancelIconHover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "currentColor",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.868 16l3.04 3.04c.117.118.12.306.011.414l-.465.465c-.11.112-.295.108-.414-.012L16 16.867l-3.04 3.04c-.118.118-.306.12-.414.012l-.465-.465c-.112-.11-.108-.295.012-.414l3.04-3.04-3.04-3.04c-.118-.118-.12-.306-.012-.414l.465-.465c.11-.112.295-.108.414.012l3.04 3.04 3.04-3.04c.118-.118.306-.12.414-.012l.465.465c.112.11.108.295-.012.414L16.867 16"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCancelIconHover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cancel-icon-hover.62ddadf28f80fb700598e2231b788883.svg";